import SampleSelectionController from './SampleSelectionController';
import Select from 'react-select';
// import Loader from 'utils/Loader';
// import { greenColor, redColor, whiteColor } from 'utils/constants';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
// import { Box, Card, Grid, TextField, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '../../../node_modules/@mui/material/index';

import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  // IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress
} from "@mui/material";

// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
import { Close } from '../../../node_modules/@mui/icons-material/index';

// import ReactSelect from 'react-select';
// import { DataGrid } from '@mui/x-data-grid';

function SampleSelection() {
  const {
    barcodeData,
    sampleRequestDocNo,
    sampleTypes,
    sampleCategory,
    setSampleCategory,
    // selectedSampleType,
    // setSelectedSampleType,
    setBarcodeSampleType,
    customerOptions,
    selectedCustomer,
    setSelectedCustomer,
    handleInputChange,
    setBarcodeSampleQuantity,
    handleAddMore,
    submitSampleRequest,
    openRemarkDialog,
    setOpenRemarkDialog,
    remark,
    setRemark,
    remarkError,
    isSubmitting,
    handleCheckout,
    handleCheckoutSubmit,
    submitRemark
  } = SampleSelectionController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;

  const cellStyles = {
    border: '1px solid rgba(224, 224, 224, 1)',
    textAlign: 'center',
    padding: '4px'
  };

  const sampleTypeSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: '2rem',
      height: '2rem',
      borderRadius: 4
    }),
    valueContainer: (base) => ({
      ...base,
      height: '2rem',
      padding: '0 8px',
      justifyContent: 'center'
    }),
    indicatorsContainer: (base) => ({ ...base, height: '2rem' }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    placeholder: (base) => ({ ...base, whiteSpace: 'nowrap' }),
    singleValue: (base) => ({ ...base, position: 'static', transform: 'none' })
  };

  // const columns = (sampleTypes, setBarcodeSampleType, setBarcodeSampleQuantity) => [
  //   {
  //     field: "materialDesc",
  //     headerName: "Description",
  //     flex: 1,
  //     minWidth: 180,
  //     renderCell: (params) => (
  //       <Typography>{params.row.materialDesc}</Typography>
  //     )
  //   },

  //   {
  //     field: "sampleType",
  //     headerName: "Sample Type",
  //     flex: 1,
  //     minWidth: 220,
  //     renderCell: (params) => {
  //       const idx = params.api.getRowIndex(params.row.id);
  //       return (
  //         <Box sx={{ width: "100%" }}>
  //           <ReactSelect
  //             value={params.row.sampleType || null}
  //             options={sampleTypes}
  //             onChange={(opt) => setBarcodeSampleType(idx, opt)}
  //             placeholder="Select Type"
  //             menuPortalTarget={document.body}
  //             styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
  //           />
  //           {params.row.errors?.sampleType && (
  //             <Typography sx={{ color: "red", fontSize: 12 }}>
  //               {params.row.errors.sampleType}
  //             </Typography>
  //           )}
  //         </Box>
  //       );
  //     }
  //   },

  //   {
  //     field: "sampleQuantity",
  //     headerName: "Quantity",
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => {
  //       const idx = params.api.getRowIndex(params.row.id);
  //       const item = params.row;

  //       return (
  //         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  //           <IconButton
  //             size="small"
  //             onClick={() => {
  //               const next = Math.max(0, (item.sampleQuantity || 0) - 1);
  //               setBarcodeSampleQuantity(idx, next);
  //             }}
  //           >
  //             <RemoveIcon fontSize="small" />
  //           </IconButton>

  //           <TextField
  //             type="text"
  //             size="small"
  //             sx={{ width: 60 }}
  //             value={item.sampleQuantity ?? 0}
  //             onChange={(e) => {
  //               const raw = e.target.value;
  //               const qty = raw === "" ? 0 : Math.max(0, parseInt(raw, 10) || 0);
  //               setBarcodeSampleQuantity(idx, qty);
  //             }}
  //             error={!!item.errors?.sampleQuantity}
  //             helperText={item.errors?.sampleQuantity || ""}
  //           />

  //           <IconButton
  //             size="small"
  //             onClick={() => {
  //               const next = (item.sampleQuantity || 0) + 1;
  //               setBarcodeSampleQuantity(idx, next);
  //             }}
  //           >
  //             <AddIcon fontSize="small" />
  //           </IconButton>
  //         </Box>
  //       );
  //     }
  //   }
  // ];

  return (
    <div className="bg" style={{ display: 'block' }}>
      {/* {isData ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null} */}
      <div className="cutrange">
        <span className="font20">SAMPLE SELECTION</span>
      </div>

      {sampleRequestDocNo ? (
        <Box sx={{ width: '80%', mx: 'auto', display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Typography sx={{ color: 'white', fontWeight: 700 }}>
            {sampleRequestDocNo}
          </Typography>
        </Box>
      ) : null}

      <Box
        sx={{
          width: '80%',
          mx: 'auto',
          mt: 2,
          p: 1.5,
          backgroundColor: '#272829',
          border: '1px solid #444',
          borderRadius: 1
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Typography sx={{ color: 'white', fontWeight: 700, whiteSpace: 'nowrap' }}>
                Party Name
              </Typography>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Select
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={(value) => setSelectedCustomer(value)}
                  onInputChange={handleInputChange}
                  placeholder="Select Party"
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-start', md: 'center' }, gap: 2 }}>
              <Typography sx={{ color: 'white', fontWeight: 700, whiteSpace: 'nowrap' }}>
                Sample Category
              </Typography>
              <Box sx={{ display: 'flex', gap: 2.5 }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'white' }}>
                  <input
                    type="radio"
                    name="sampleCategory"
                    value="Retail"
                    checked={sampleCategory === "Retail"}
                    onChange={() => setSampleCategory("Retail")}
                    style={{ width: 16, height: 16, margin: '0 7px 0 0', accentColor: '#ff0000' }}
                  />
                  Retail Sample
                </label>

                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'white' }}>
                  <input
                    type="radio"
                    name="sampleCategory"
                    value="Replenishment"
                    checked={sampleCategory === "Replenishment"}
                    onChange={() => setSampleCategory("Replenishment")}
                    style={{ width: 16, height: 16, margin: '0 7px 0 0', accentColor: '#ff0000' }}
                  />
                  Replenishment
                </label>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <div className="vertical-center">

        {shouldRenderTable ? (
          <TableContainer
            component={Paper}
            sx={{ width: "100%", my: 2, maxHeight: 430 }}
          >
            <Table stickyHeader sx={{ minWidth: 650 }} size="small" aria-label="Sample selection list">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...cellStyles, backgroundColor: '#272829', color: 'white', fontWeight: 700, width: '40%' }}>
                    Description
                  </TableCell>
                  <TableCell sx={{ ...cellStyles, backgroundColor: '#272829', color: 'white', fontWeight: 700, width: '30%' }}>
                    Sample Type
                  </TableCell>
                  <TableCell sx={{ ...cellStyles, backgroundColor: '#272829', color: 'white', fontWeight: 700, width: '30%' }}>
                    Quantity
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {barcodeData.map((item, idx) => (
                  <TableRow key={item.id ?? idx} hover>
                    <TableCell sx={cellStyles}>{item.materialDesc || "-"}</TableCell>
                    <TableCell sx={{ ...cellStyles, minWidth: 240 }}>
                      <Box>
                        <Select
                          value={item.sampleType ?? null}
                          onChange={(opt) => setBarcodeSampleType(idx, opt)}
                          options={sampleTypes}
                          placeholder="Sample type"
                          menuPortalTarget={document.body}
                          styles={sampleTypeSelectStyles}
                        />
                        {item.errors?.sampleType && (
                          <Typography sx={{ color: "red", fontSize: 12 }}>
                            {item.errors.sampleType}
                          </Typography>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ ...cellStyles, minWidth: 200 }}>
                      <Box sx={{ width: "100%" }}>
                        <TextField
                          placeholder="Enter Quantity"
                          type="text"
                          variant="outlined"
                          size="small"
                          fullWidth
                          sx={{
                            '& .MuiInputBase-root': {
                              height: '2rem',
                              backgroundColor: 'white'
                            },
                            '& input': { textAlign: 'center', padding: '4px 8px' }
                          }}
                          value={item.sampleQuantity ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (/^\d*$/.test(value)) {
                              const qty = value === "" ? "" : Number(value);
                              setBarcodeSampleQuantity(idx, qty);
                            }
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            min: 0,
                            maxLength: 3
                          }}
                          error={Boolean(item.errors?.sampleQuantity)}
                          helperText={item.errors?.sampleQuantity || ""}
                          FormHelperTextProps={{ sx: { color: "red", margin: '2px 0 0' } }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}
      </div>

      <div className="footer-button">
        <button style={{ marginRight: '15px' }} onClick={submitSampleRequest} disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleAddMore} disabled={isSubmitting}>
          {'Add More'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleCheckout}>
          {'Checkout'}
        </button>
      </div>

      <Dialog
        open={openRemarkDialog}
        onClose={() => {
          if (!isSubmitting) setOpenRemarkDialog(false);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            width: '100%',
            fontWeight: 'bold',
            fontSize: '1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 0,
          }}
        >
          Remarks
          <Close
            onClick={() => {
              if (!isSubmitting) setOpenRemarkDialog(false);
            }}
            sx={{ cursor: isSubmitting ? 'not-allowed' : 'pointer', opacity: isSubmitting ? 0.5 : 1 }}
          />
        </DialogTitle>

        <DialogContent dividers>
          <textarea
            type="text"
            name="remark"
            value={remark}
            className="form-control inp_text"
            id="remark"
            rows={7}
            cols={50}
            maxLength={1000}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Write Remark Here..."
            autoFocus
          />
          <div style={{ textAlign: 'right', fontSize: '12px', color: '#000000' }}>
            {remark.length}/1000
          </div>

          {remarkError && (
            <Typography
              variant="body2"
              sx={{ color: "red", mt: 1, fontSize: "0.9rem" }}
            >
              {remarkError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'end', px: 3, py: 2, gap: 1 }}>
          <Button
            variant="outlined"
            sx={{
              fontWeight: 'bold',
              minWidth: 110,
            }}
            onClick={() => setOpenRemarkDialog(false)}
            disabled={isSubmitting}
          >
            Close
          </Button>
          <Button
            variant="contained"
            sx={{
              fontWeight: 'bold',
              minWidth: 130,
            }}
            onClick={() => handleCheckoutSubmit()}
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {isSubmitting ? 'Saving...' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SampleSelection;
